<template>
  <v-container>
    <v-content class="mic_container">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-form ref="profileForm" v-model="valid" lazy-validation class="mic_form">
            <v-toolbar dark color="#5ba322">
              <v-toolbar-title>MindCarb Teilnehmer erstellen</v-toolbar-title>
            </v-toolbar>
            <v-spacer></v-spacer>
            <div class="mic_form-content">
              <v-select
                v-model="birthYear"
                :items="birthYearItems"
                :rules="birthYearRules"
                label="Geburtsjahr *"
                :disabled="disabled == true"
                required
              ></v-select>
              <v-radio-group
                v-model="gender"
                :rules="genderRules"
                label="Geschlecht *"
                :disabled="disabled == true"
                required>
                <v-radio label="weiblich" value="female"></v-radio>
                <v-radio label="männlich" value="male"></v-radio>
              </v-radio-group>
              <div style="margin-top: 15px!important">
                <label aria-hidden="true" class="v-label theme--light">Ernährungstyp *</label>
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">{{nutritionalTypeHint}}</div>
                  </div>
                </div>
              </div>
              <v-radio-group
                v-model="nutritionalType"
                :rules="nutritionalTypeRules"
                :disabled="disabled == true"
                required>
                <v-radio label="Fleisch essend" value="Fleisch essend"></v-radio>
                <v-radio label="vegetarisch" value="vegetarisch"></v-radio>
                <v-radio label="vegan" value="vegan"></v-radio>
              </v-radio-group>
              <div style="margin-top: 15px!important">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">{{kindOfNutritionHint}}</div>
                  </div>
                </div>
                <v-select
                  v-model="kindOfNutrition"
                  :items="kindOfNutritionItems"
                  item-text="label"
                  item-value="value"
                  :rules="kindOfNutritionRules"
                  label="Ernährungsart *"
                  :disabled="disabled == true"
                  required
                ></v-select>
              </div>
              <div style="margin-top: 15px!important">
                <label aria-hidden="true" class="v-label theme--light">Beginn der MindCarb Ernährung *</label>
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">{{beginLowCarbNutritionHint}}</div>
                  </div>
                </div>
                <v-menu
                  ref="beginLowCarbNutritionMenu"
                  :close-on-content-click="false"
                  v-model="beginLowCarbNutritionMenu"
                  :nudge-right="40"
                  :return-value.sync="beginLowCarbNutrition"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="computedDateFormatted"
                    persistent-hint
                    prepend-icon="event"
                    @blur="beginLowCarbNutrition = parseDate(beginLowCarbNutritionFormatted)"
                    :rules="beginLowCarbNutritionRules"
                    :disabled="disabled == true"
                    required
                  ></v-text-field>
                  <v-date-picker v-model="beginLowCarbNutrition" no-title scrollable required>
                    <v-spacer></v-spacer>
                    <v-btn flat color="#5ba322" @click="beginLowCarbNutritionMenu = false">Cancel</v-btn>
                    <v-btn
                      flat
                      color="#5ba322"
                      @click="$refs.beginLowCarbNutritionMenu.save(beginLowCarbNutrition)"
                    >OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                color="#f5a900"
                @click="handleSubmit"
                :disabled="disabled == true"
                class="white--text"
              >Profil speichern</v-btn>
            </div>
          </v-form>
        </v-layout>
      </v-container>
    </v-content>
  </v-container>
</template>

<script>
import { trackingService } from '../_services'
export default {
  data () {
    return {
      disabled: false,
      valid: true,
      birthYear: '',
      birthYearItems: this.years,
      birthYearRules: [v => !!v || 'Geburtsjahr ist ein Pflichtfeld'],
      gender: '',
      genderRules: [v => !!v || 'Geschlecht ist ein Pflichtfeld'],
      nutritionalType: '',
      nutritionalTypeHint: 'Welcher Ernährungstyp sind Sie?',
      nutritionalTypeRules: [
        v => !!v || 'Ernährungstyp ist ein Pflichtfeld'
      ],
      kindOfNutrition: '',
      kindOfNutritionHint:
        'Ernährung bisher, vor Studienbeginn, bitte Wert auswählen',
      kindOfNutritionItems: [
        {
          label:
            'Fettarm/Kohlenhydratreich',
          value: 'FETTARMKOHLENHYDRATREICH'
        },
        {
          label: 'Fett- und Kohlenhydratreich',
          value: 'FETTKOHLENHYDRATREICH'
        },
        {
          label:
            'Gemüse-/Olivenölbetont und Kohlenhydratreich',
          value: 'GEMUESEOLIVENOELBETONT'
        },
        {
          label:
            'Low-Carb',
          value: 'LOWCARB'
        }
      ],
      kindOfNutritionRules: [v => !!v || 'Ernährungsart ist ein Pflichtfeld'],
      beginLowCarbNutritionMenu: false,
      beginLowCarbNutritionHint:
        'Datum Beginn der MindCarb Ernährung',
      beginLowCarbNutrition: new Date().toISOString().substr(0, 10),
      beginLowCarbNutritionFormatted: this.formatDate(
        new Date().toISOString().substr(0, 10)
      ),
      beginLowCarbNutritionRules: [
        v => !!v || 'Datum Verlaufskontrolle ist ein Pflichtfeld'
      ]
    }
  },
  beforeMount () {
    this.birthYearItems = this.years
    trackingService
      .getProfile(JSON.parse(localStorage.getItem('user')).id)
      .then(
        response => {
          if (response != null) {
            if (parseInt(response.data.birthYear) && response.data.gender && response.data.nutritionalType && response.data.kindOfNutrition && response.data.beginLowCarbNutrition) {
              this.disabled = true
            }
            this.birthYear = parseInt(response.data.birthYear)
            this.gender = response.data.gender
            this.nutritionalType = response.data.nutritionalType
            this.kindOfNutrition = response.data.kindOfNutrition
            this.beginLowCarbNutrition = response.data.beginLowCarbNutrition
          }
        },
        error => {
          console.log(error)
        }
      )
  },
  computed: {
    years () {
      const year = new Date().getFullYear()
      return Array.from(
        { length: year - 1900 },
        (value, index) => 1901 + index
      ).sort((a, b) => {
        if (a < b) {
          return 1
        }
        return -1
      })
    },
    computedDateFormatted () {
      return this.formatDate(this.beginLowCarbNutrition)
    }
  },
  watch: {
    date (val) {
      this.beginLowCarbNutritionFormatted = this.formatDate(
        this.beginLowCarbNutrition
      )
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    handleSubmit () {
      if (this.$refs.profileForm.validate()) {
        const { dispatch } = this.$store

        let profile = {
          userId: JSON.parse(localStorage.getItem('user')).id,
          birthYear: this.birthYear,
          gender: this.gender,
          nutritionalType: this.nutritionalType,
          kindOfNutrition: this.kindOfNutrition,
          beginLowCarbNutrition: this.beginLowCarbNutrition
        }

        trackingService.saveProfile(profile).then(
          response => {
            dispatch('alert/success', 'Profil wurde erfolgreich gespeichert.', {
              root: true
            })
            this.$router.push('/tracking/overview')
          },
          error => {
            console.log(error)
            dispatch('alert/error', 'Fehler beim Speichern des Profils.', {
              root: true
            })
          }
        )
      }
    }
  }
}
</script>

<style scoped="true">
.v-text-field {
  padding-top: 5!important;
  margin-top: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/profile/ProfilePage.vue